import { render, staticRenderFns } from "./ShippingIntegrationsList.vue?vue&type=template&id=00ff86c3&"
import script from "./ShippingIntegrationsList.vue?vue&type=script&lang=js&"
export * from "./ShippingIntegrationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports